<template lang="pug">
v-list(
    v-bind='$attrs'
    :density='density'
    :variant='variant'
    :lines='lines'
    :select-strategy='selectStrategy'
) 
    slot
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'BaseListWrapper',
    inheritAttrs: false,
    props: {
        lines: {
            type: String,
            default: 'one',
        },
        density: {
            type: String,
            default: 'default',
        },
        variant: {
            type: String,
            default: 'flat',
        },
        selectStrategy: {
            type: String,
            default: 'single-leaf',
        },
    },
});
</script>
